export default __webpack_public_path__ + "static/media/article.130146c3.jpg";